import { invoke } from '@tauri-apps/api/core';

/**
 * Opens the native sharing interface to share the specified text.
 *
 * ```javascript
 * import { shareText } from "@choochmeque/tauri-plugin-sharekit-api";
 * await shareText('I am a shared message');
 * ```
 * @param text
 * @param options
 * @returns
 */
async function shareText(text, options) {
    await invoke("plugin:sharekit|share_text", {
        text,
        ...options,
    });
}
/**
 * Opens the native sharing interface to share a file.
 *
 * ```javascript
 * import { shareFile } from "@choochmeque/tauri-plugin-sharekit-api";
 * await shareFile('file:///path/to/file.pdf', {
 *   mimeType: 'application/pdf',
 *   title: 'Document.pdf'
 * });
 * ```
 * @param url - The file URL to share (must be a file:// URL)
 * @param options - Optional settings including MIME type and title
 * @returns
 */
async function shareFile(url, options) {
    await invoke("plugin:sharekit|share_file", {
        url,
        ...options,
    });
}

export { shareFile, shareText };
